// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CENTER_UPDATE_QUESTION_STORE,
} from './constants';

export function updateQuestionStore(data) {
  return {
    type: CENTER_UPDATE_QUESTION_STORE,
    payload: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CENTER_UPDATE_QUESTION_STORE:
      return {
        ...state,
        fetchGetQuestionStoreSelect: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/center/redux/updateQuestionStore.js